import axios from 'axios';
import { authHeader } from '../_helpers';
import config from '../_helpers/_config';

export const extraTagService = {
    executeExtraTag    
};

async function executeExtraTag(projectId, tag) {
    return axios({
        method: 'put',
        url: `${config.API_LOCATION}/extraTags/execute/tag`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
        data: tag
    });
}
